var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512.429 512.429",
    height: 512,
    viewBox: "0 0 512.429 512.429",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512.429 223.472-256.215-222.502-256.214 222.502 26.228 30.201 21.987-19.094v216.879c0 33.084 26.916 60 60 60h296c33.084 0 60-26.916 60-60v-216.879l21.987 19.094zm-88.215 227.987c0 11.028-8.972 20-20 20h-296c-11.028 0-20-8.972-20-20v-251.617l168-145.895 168 145.895zm-213.5-232c-17.906 0-34.392 6.723-46.419 18.929-12.304 12.487-19.081 30.059-19.081 49.479 0 23.219 13.792 47.893 40.993 73.336 23.285 21.781 48.796 37.063 53.676 39.907 1.96 1.142 16.335 9.45 16.335 9.45s14.367-8.309 16.327-9.451c4.878-2.843 30.391-18.126 53.675-39.906 27.202-25.444 40.995-50.118 40.995-73.337 0-19.42-6.776-36.992-19.081-49.479-12.028-12.207-28.513-18.929-46.419-18.929-21.581 0-36.436 7.421-46.045 15.135-9.596-7.608-24.307-15.134-44.956-15.134zm116.5 68.408c0 23.229-40.297 57.674-71.001 76.41-30.704-18.736-70.999-53.18-70.999-76.41 0-17.258 10.009-28.409 25.5-28.409 1.967 0 3.798.146 5.512.396 25.117 7.107 40.282 39.928 40.282 39.928s13.261-32.472 38.331-39.81c2.081-.323 4.363-.514 6.876-.514 15.49.001 25.499 11.152 25.499 28.409z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.64e08620eb10842f5a617aa29e4341d7.svg";
export { ForwardRef as ReactComponent };